import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { updateEndgameMetadata } from "api/game/update-endgame-metadata";
import { useSnackbar } from "notistack";
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { GameContext } from "./GamePage";

export const Component: React.FC = () => {
  const { gameId } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const [note, setNote] = useState("");
  const [allowReplay, setAllowReplay] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { game } = useContext(GameContext);
  const playerId = game?.player?.UserId;
  const originalNote = game?.endgameNotes.find((entry) => entry.playerId === playerId)?.note ?? "";
  const originalAllowReplay =
    game?.replayConsents.find((entry) => entry.playerId === playerId)?.allowReplay ?? false;
  const isDirty = note !== originalNote || allowReplay !== originalAllowReplay;

  useEffect(() => {
    if (!game || !playerId) {
      return;
    }
    setNote(originalNote);
    setAllowReplay(originalAllowReplay);
  }, [game, playerId, originalNote, originalAllowReplay]);

  const handleSubmit = async () => {
    if (!gameId) {
      enqueueSnackbar("Missing game id", { variant: "error" });
      return;
    }
    setIsSubmitting(true);
    await updateEndgameMetadata(gameId, {
      note,
      allowReplay,
    });
    setIsSubmitting(false);
  };

  return (
    <Box display="flex" justifyContent="center" width="100%">
      <Card sx={{ width: { xs: "100%", md: 520 }, maxWidth: 520, flexShrink: 0 }}>
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Endgame notes"
            value={note}
            onChange={(event) => setNote(event.target.value)}
            multiline
            minRows={3}
            fullWidth
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={allowReplay}
                onChange={(event) => setAllowReplay(event.target.checked)}
              />
            }
            label="Allow this game to be used for replays"
          />
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={isSubmitting || note.trim().length === 0 || !isDirty}
            >
              {isSubmitting ? "Submitting..." : isDirty ? "Submit" : "No changes"}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

Component.displayName = "EndgameNote";
